export interface HandoffPlan {message:string;steps:string[];}
/** Time the reveal of proposed steps only. Real activity and answers interrupt it immediately. */
export class HandoffSequence {
  private key='';private timer?:ReturnType<typeof setTimeout>;
  private show:(label:string)=>void;private random:()=>number;
  constructor(show:(label:string)=>void,random=()=>Math.random()){this.show=show;this.random=random;}
  update(plan?:HandoffPlan){
    const key=plan?JSON.stringify(plan):'';if(key===this.key)return;
    this.dispose();this.key=key;
    const steps=plan?.steps.slice(0,12)??[];if(!steps.length){this.show('');return;}
    let index=0;const reveal=()=>{
      this.show(steps[index++]);
      if(index<steps.length)this.timer=setTimeout(reveal,1200+Math.floor(this.random()*1200));
    };reveal();
  }
  dispose(){clearTimeout(this.timer);this.timer=undefined;this.key='';}
}
